import { useState, useEffect } from 'react';
import { API_URL } from '../config';

export const DRY_CLEANING_FLAG_CHANGED_EVENT = 'app-dry-cleaning-flag-changed';
const STORAGE_KEY = 'dry_cleaning_enabled';

let cachedFlag = null;

const normalizeFlag = (value) => {
  if (value === null || value === undefined) return true;
  if (typeof value === 'boolean') return value;
  const str = String(value).trim().toLowerCase();
  return !['0', 'false', 'no', 'off'].includes(str);
};

export const getDryCleaningEnabled = () => {
  if (cachedFlag !== null) {
    return cachedFlag;
  }
  if (typeof localStorage === 'undefined') {
    return true;
  }
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored === null) {
    return true;
  }
  cachedFlag = normalizeFlag(stored);
  return cachedFlag;
};

export const setDryCleaningEnabled = (value) => {
  const normalized = normalizeFlag(value);
  cachedFlag = normalized;

  if (typeof localStorage !== 'undefined') {
    localStorage.setItem(STORAGE_KEY, normalized ? 'true' : 'false');
  }

  if (typeof window !== 'undefined') {
    window.dispatchEvent(
      new CustomEvent(DRY_CLEANING_FLAG_CHANGED_EVENT, {
        detail: { enabled: normalized }
      })
    );
  }

  return normalized;
};

export const loadDryCleaningEnabled = async (tokenOverride) => {
  try {
    const token = tokenOverride || (typeof localStorage !== 'undefined' ? localStorage.getItem('token') : null);
    if (!token) {
      return getDryCleaningEnabled();
    }
    const response = await fetch(`${API_URL}/api/settings/dry_cleaning_enabled`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    if (response.ok) {
      const data = await response.json();
      return setDryCleaningEnabled(data.value);
    }
  } catch (error) {
    console.error('Ошибка загрузки настройки химчистки:', error);
  }
  return getDryCleaningEnabled();
};

export const useDryCleaningEnabled = () => {
  const [enabled, setEnabled] = useState(() => getDryCleaningEnabled());

  useEffect(() => {
    const handleChange = (e) => {
      if (e?.detail && typeof e.detail.enabled === 'boolean') {
        setEnabled(e.detail.enabled);
      } else {
        setEnabled(getDryCleaningEnabled());
      }
    };

    const handleStorage = (e) => {
      if (e.key === STORAGE_KEY) {
        setEnabled(normalizeFlag(e.newValue));
      }
    };

    window.addEventListener(DRY_CLEANING_FLAG_CHANGED_EVENT, handleChange);
    window.addEventListener('storage', handleStorage);
    return () => {
      window.removeEventListener(DRY_CLEANING_FLAG_CHANGED_EVENT, handleChange);
      window.removeEventListener('storage', handleStorage);
    };
  }, []);

  return enabled;
};
